<app-event-select
  [onlyActive]="false"
  [onlyIncoming]="false"
  (select)="onSelect($event)"
  [hideLabel]="true"
  [parentFormGroup]="form"
  class="kendo-select-filter"
  [isInModal]="false"
>
</app-event-select>
